import launcherBrandBadge from './brandBadge/launcher';
import launcherProductBadge from './productBadge/launcher';
import launcherProductReviewFeed from './productReviewFeed/launcher';

const rootLauncher = () => {
  launcherBrandBadge();
  launcherProductBadge();
  launcherProductReviewFeed();
};

export default rootLauncher;